import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSeparator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 2,
	viewBox: "0 0 26 2",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("line", {
		x1: .602007,
		y1: 1.39799,
		x2: 25.398,
		y2: 1.39799,
		stroke: "#2C3F81",
		strokeWidth: 1.20401,
		strokeLinecap: "round"
	})
});
export default SvgSeparator;
